<template>
	<div class="modal">
		<div class="modal-content update-cost-modal">
			<p class="btn" v-on:click="closeModal">x</p>
			<form v-on:submit.prevent="handleSubmit">
				<div class="input-ctn">
					<div class="label">Other Cost</div>
					<input
						type="text"
						class="input"
						placeholder="Other Cost"
						v-model="costs.internationalShippingCost"
					/>
				</div>
				<!-- <div class="input-ctn">
					<div class="label">Chinese Shipping Cost</div>
					<input
						type="text"
						class="input"
						placeholder="Chinese Shipping Cost"
						v-model="costs.chineseShippingCost"
					/>
				</div> -->
				<div class="submit">
					<p v-if="loading" class="btn disabled-btn">Updating . . .</p>
					<button v-if="!loading" type="submit" class="btn">Update</button>
				</div>
			</form>
		</div>
	</div>
</template>

<script>
export default {
	props: [
		"onSubmit",
		"closeModal",
		"internationalShippingCost",
		"chineseShippingCost",
	],
	data() {
		return {
      loading: false,
			costs: {
				internationalShippingCost: this.internationalShippingCost,
				chineseShippingCost: this.chineseShippingCost,
			},
		};
	},
	methods: {
		async handleSubmit() {
            this.loading = true;
            const {internationalShippingCost, chineseShippingCost} = this.costs;
            this.onSubmit({internationalShippingCost,chineseShippingCost})
        },
	},
};
</script>

<style></style>
